'use strict';

var styled = require('styled-components');
var number = require('../../helpers/number.js');
var component$1 = require('../Text/component.js');
var component = require('../Heading/component.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const Container = styled__default.default.div `
  max-width: ${({ maxWidth }) => (number.isNumber(maxWidth) ? `${maxWidth}px` : maxWidth)};
`;
const textSubStyles = styled.css `
  color: ${({ theme }) => theme.designTokens.cellTextSubSubColor};
  font-weight: ${({ theme }) => theme.designTokens.cellTextSubSubFontWeight};
  line-height: ${({ theme }) => theme.designTokens.heading5LineHeight};
`;
const SubHeading = styled__default.default(component.Heading) `
  ${textSubStyles};
  overflow: hidden;
`;
const SubText = styled__default.default(component$1.Text) `
  ${textSubStyles};
  overflow: hidden;
`;
const Styled = {
    Container,
    SubHeading,
    SubText,
};

exports.Styled = Styled;
//# sourceMappingURL=styles.js.map
